import { Box, Button, IconButton, Typography } from '@mui/material';
import { DataGridPro, GridToolbarQuickFilter } from '@mui/x-data-grid-pro';
import React from 'react'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import dayjs from "dayjs";

function DataGridMyEOC({ columns, rows, activityData, handleClickEdit, handleClickDelete, handleClickDetail, actions }) {

    const activity_columns = [
        {
            field: 'create_timestamp',
            headerName: 'วันที่เริ่มต้น',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            valueGetter: (value) => {
                if (value?.row?.create_timestamp) {
                    const date = new Date(parseInt(value?.row?.create_timestamp));
                    let startEOCDate = dayjs(date).locale("th").format("DD MMMM YYYY");
                    return startEOCDate;
                }
            },
            renderCell: (params) => {
                if (params?.row?.create_timestamp) {
                    const date = new Date(parseInt(params?.row?.create_timestamp));
                    let startEOCDate = dayjs(date).locale("th").format("DD MMMM YYYY");
                    return <Typography>{startEOCDate}</Typography>;
                }
            }
        },
        {
            field: 'eoc_activity',
            headerName: 'กิจกรรม',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            valueGetter: (value) => {
                if (value?.row?.activity) {
                    const join_activity = value?.row?.activity.join();
                    return join_activity;
                } else {
                    return;
                }
            },
            renderCell: (params) => {
                if (params?.row?.activity) {
                    const join_activity = params?.row?.activity.join();
                    return <Typography noWrap>{join_activity}</Typography>;
                } else {
                    return;
                }
            }
        },
        {
            field: 'actions',
            headerName: '',
            flex: 1,
            align: 'right',
            headerAlign: 'center',
            renderCell: (params) => {
                return <div>
                    <IconButton onClick={() => handleClickEdit(params?.row)}>
                        <EditIcon />
                    </IconButton>
                    <IconButton onClick={() => handleClickDelete(params?.row)}>
                        <DeleteIcon />
                    </IconButton>
                </div>
            }
        },
        {
            field: 'details',
            headerName: '',
            flex: 1,
            align: 'left',
            headerAlign: 'center',
            renderCell: (params) => {
                return <Button variant="outlined" size='small' onClick={() => handleClickDetail(params?.row)}>รายละเอียด</Button>;
            }
        },
    ];

    const activity_columns_no_action = [
        {
            field: 'create_timestamp',
            headerName: 'วันที่เริ่มต้น',
            flex: 1,
            align: 'center',
            headerAlign: 'center',

            renderCell: (params) => {
                if (params?.row?.create_timestamp) {
                    const date = new Date(parseInt(params?.row?.create_timestamp));
                    let startEOCDate = dayjs(date).locale("th").format("DD MMMM YYYY");
                    return <Typography>{startEOCDate}</Typography>;
                }
            }
        },
        {
            field: 'eoc_activity',
            headerName: 'กิจกรรม',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            valueGetter: (value) => {
                if (value?.row?.activity) {
                    const join_activity = value?.row?.activity.join();
                    return join_activity;
                } else {
                    return;
                }
            },
            renderCell: (params) => {
                if (params?.row?.activity) {
                    const join_activity = params?.row?.activity.join();
                    return <Typography noWrap>{join_activity}</Typography>;
                } else {
                    return;
                }
            }
        },
        {
            field: 'details',
            headerName: '',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                return <Button variant="outlined" size='small' onClick={() => handleClickDetail(params?.row)}>รายละเอียด</Button>;
            }
        },
    ];

    const data_rows = rows.map((row, index) => ({ ...row, id: index }));

    function QuickSearchToolbar() {
        return (
            <div>
                <Box
                    sx={{
                        p: 1,
                    }}
                >
                    <GridToolbarQuickFilter variant='outlined' size='small' placeholder='ค้นหา...' />
                </Box>
            </div>
        );
    }

    return (
        <div className='w-full h-full'>
            <DataGridPro
                rows={data_rows}
                columns={activityData ? (actions ? activity_columns : activity_columns_no_action) : columns}
                density="standard"
                disableColumnSelector
                disableDensitySelector
                hideFooter
                slots={{ toolbar: QuickSearchToolbar }}
            />
        </div>
    )
}

export default DataGridMyEOC